
const welcomePopup = () => {
    return(
        <div dir='rtl' className='absolute -top-[200px] left-[50%] -translate-x-1/2 z-10 w-[60vw] sm:w-[35vw] md:w-[30vw] lg:w-[25vw] xl:w-[20vw] bg-green-500 text-white border border-gray-600
        rounded-md py-3 px-2 animate-showWelcome text-xs sm:text-sm'
        >
            <i className="fa fa-solid fa-check ml-3"></i><span>{localStorage.getItem('userName')}</span> <span>عزیز خوش آمدید!</span>
        </div>
    )
}

export default welcomePopup